<apm-custom-checkbox
  class="ms-1 mb-2 text"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [ngClass]="{ bold: formControl.value }"
  [defaultValue]="field.defaultValue"
  [enabledValue]="customProps.enabledValue"
  [disabledValue]="customProps.disabledValue"
>
  {{ props.resourceId ? (props.resourceId | apmTranslate) : props.label }}
</apm-custom-checkbox>
